class PickupAvailability extends HTMLElement {
    constructor() {
        super();

        this.container = this.closest('.productView-moreItem');
        this.onClickRefreshList = this.onClickRefreshList.bind(this);

        if (!this.hasAttribute('available')) {
            this.hideContainer();
            return;
        }

        const template = this.querySelector('template');
        this.errorHtml = template?.content?.firstElementChild?.cloneNode(true) || null;
        this.fetchAvailability(this.dataset.variantId);
    }

    hideContainer() {
        this.container?.classList.add('hidden');
    }

    showContainer() {
        this.container?.classList.remove('hidden');
    }

    fetchAvailability(variantId) {
        if (!variantId) {
            this.renderError();
            return;
        }

        const rootUrl = this.dataset.rootUrl || this.dataset.baseUrl || '/';
        const normalizedRoot = rootUrl.endsWith('/') ? rootUrl : `${rootUrl}/`;
        const variantSectionUrl = `${normalizedRoot}variants/${encodeURIComponent(variantId)}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Pickup availability request failed with status ${response.status}`);
                }
                return response.text();
            })
            .then(text => {
                const sectionInnerHTML = new DOMParser()
                    .parseFromString(text, 'text/html')
                    .querySelector('.shopify-section');

                if (!sectionInnerHTML) {
                    throw new Error('Pickup availability section markup was not returned');
                }

                this.renderPreview(sectionInnerHTML);
            })
            .catch(error => {
                console.warn('Pickup availability could not be loaded.', error);
                this.querySelector('button')?.removeEventListener('click', this.onClickRefreshList);
                this.renderError();
            });
    }

    onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
    }

    renderError() {
        this.innerHTML = '';

        if (!this.errorHtml) {
            this.removeAttribute('available');
            this.hideContainer();
            return;
        }

        this.appendChild(this.errorHtml.cloneNode(true));
        this.showContainer();
        this.querySelector('button')?.addEventListener('click', this.onClickRefreshList);
    }

    renderPreview(sectionInnerHTML) {
        document.querySelector('pickup-availability-drawer')?.remove();

        const preview = sectionInnerHTML?.querySelector('pickup-availability-preview');
        const incomingDrawer = sectionInnerHTML?.querySelector('pickup-availability-drawer');

        if (!preview) {
            this.innerHTML = '';
            this.removeAttribute('available');
            this.hideContainer();
            return;
        }

        this.showContainer();
        this.innerHTML = preview.outerHTML;
        this.setAttribute('available', '');

        if (incomingDrawer) {
            document.body.appendChild(incomingDrawer);
        }

        this.querySelector('button')?.addEventListener('click', (evt) => {
            document.querySelector('pickup-availability-drawer')?.show(evt.currentTarget);
        });
    }
}

if (!customElements.get('pickup-availability')) {
    customElements.define('pickup-availability', PickupAvailability);
}

class PickupAvailabilityDrawer extends HTMLElement {
    constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('button')?.addEventListener('click', () => {
            this.hide();
        });

        this.addEventListener('keyup', (event) => {
            if (event.code?.toUpperCase() === 'ESCAPE') this.hide();
        });
    }

    handleBodyClick(evt) {
        const target = evt.target;
        if (target !== this && !target.closest('pickup-availability-drawer') && target.id !== 'ShowPickupAvailabilityDrawer') {
            this.hide();
        }
    }

    hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        document.body.classList.remove('show-pickup-availability');
        if (this.focusElement) removeTrapFocus(this.focusElement);
    }

    show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        document.body.classList.add('show-pickup-availability');
        trapFocus(this);
    }
}

if (!customElements.get('pickup-availability-drawer')) {
    customElements.define('pickup-availability-drawer', PickupAvailabilityDrawer);
}